import { Either, isRight, Right } from "fp-ts/lib/Either";
import { Async, isLoaded, Loaded } from "./Async";

export type Validatable<TIncomplete, TValid> = Async<
  Either<TIncomplete, TValid>
>;

export const isValid = <TIncomplete, TValid>(
  validatable: Validatable<TIncomplete, TValid>
): validatable is Loaded<Right<TValid>> => {
  return isLoaded(validatable) && isRight(validatable.Data);
};
